module.exports = __webpack_public_path__ + "static/media/disabled.6f14c383.svg";